export const usPhone = ['(', /[2-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
export const cardNumber = [/[0-9]/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
export const expirationDate = [/[0-9]/, /\d/, '/', /\d/, /\d/];
export const cvv = [/[0-9]/, /\d/, /\d/];
export const year = [/[0-9]/, /\d/, /\d/, /\d/];
export const day = [/[0-9]/, /\d/];